export const TOKEN = 'MUxHbE95aVJkT2E5dkI5Nmo0N2xmdz09'

export const API_ENDPOINT = 'https://globaljetdemo1.recruitee.com/api'
